import {Swiper, SwiperSlide} from "swiper/react";
import {useData} from "vike-react/useData";
import {ApiArticle, ApiBlogPostData} from "#/src/definitions/ApiDefinitions";
import {useRef} from "react";
import {Swiper as SwiperCore} from "swiper/types";
import {Sort} from "#/src/utils/sort-utils";
import {ArticleCard} from "#/src/components/ArticleCard";
import {DataWrapped} from "#/src/definitions/AppDefinitions";

export function RelatedArticles() {
  const {data: blogData} = useData() as DataWrapped<ApiBlogPostData>;
  const swiperRef = useRef<SwiperCore>();
  const relatedArticles = Sort.byDate(blogData.relatedArticles);
  if(relatedArticles.length == 0) {
    return <></>
  }
  return <section className="last-article mb-6">
    <div className="container-xxl">
      <div className="row">
        <div className="col-xl-12">
          <div className="title-arrow">
            <h2 className="basic-headline">
              Podobne artykuły
            </h2>
            <div className="arrow-group ms-3">
              <button type="button" className="prev" onClick={() => swiperRef.current?.slidePrev()}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.5 5L7.5 10L12.5 15" stroke="#EEF5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <button type="button" className="next" onClick={() => swiperRef.current?.slideNext()}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.5 15L12.5 10L7.5 5" stroke="#EEF5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <Swiper
            direction={"horizontal"}
            loop={true}
            grabCursor={true}
            slidesPerView={"auto"}
            spaceBetween={30}
            navigation={{nextEl: ".next", prevEl: ".prev"}}
            breakpoints={{
              340: {slidesPerView: 1.5, spaceBetween: 20},
              540: {slidesPerView: 2.15, spaceBetween: 30},
              720: {slidesPerView: 2.15, spaceBetween: 30,},
              960: {slidesPerView: 3.2, spaceBetween: 30},
              1140: {slidesPerView: 3, spaceBetween: 30},
              1290: {slidesPerView: 4, spaceBetween: 30}
            }}
            onBeforeInit={(swiper) => swiperRef.current = swiper}>
            {relatedArticles.map((article: ApiArticle) => {
              return <SwiperSlide key={article.id}><ArticleCard article={article}/></SwiperSlide>
            })}
          </Swiper>
        </div>
      </div>
    </div>
  </section>
}